import { sumBy, toFinite } from "lodash";
import { AccommodationPaymentMethod } from "@bonliva-crm/shared";

type WeekLine = {
  paymentMethod: string;
  cost: number;
  extraCost: number;
  tax: number;
};

export interface WeekPayFormTotals {
  /** Benefit tax that reaches the PayForm: only stays Bonliva pays. */
  tax: number;
  /** The week's Kostnad + Övriga, every stay in it included. */
  cost: number;
  /** Cost + extra cost taken from the consultant's net pay. */
  salaryDeduction: number;
}

/**
 * What a week costs, taxes the consultant and deducts from their pay. The cost
 * is the week's own Kostnad + Övriga. ERP's own week tax sums every
 * reservation, including ones Bonliva does not tax, so a week with lines is
 * summed from them instead. A week without lines is one stay Bonliva pays and
 * keeps its own tax.
 */
export function getWeekPayFormTotals(week: {
  cost: number | string;
  extraCost: number | string;
  tax: number | string;
  lines?: WeekLine[];
}): WeekPayFormTotals {
  const cost = toFinite(week.cost) + toFinite(week.extraCost);
  if (!week.lines?.length) {
    return {
      tax: toFinite(week.tax),
      cost,
      salaryDeduction: 0
    };
  }

  const ofMethod = (method: AccommodationPaymentMethod) =>
    week.lines.filter((x) => x.paymentMethod === method);
  const costOf = (lines: WeekLine[]) =>
    sumBy(lines, (x) => toFinite(x.cost) + toFinite(x.extraCost));
  return {
    tax: sumBy(ofMethod(AccommodationPaymentMethod.BonlivaPays), (x) => toFinite(x.tax)),
    cost,
    salaryDeduction: costOf(ofMethod(AccommodationPaymentMethod.DeductFromSalary))
  };
}
